<app-sidebar *ngIf="authService.isLoggedIn()"></app-sidebar>
<div class="content" [class.content--login]="!authService.isLoggedIn()">
  <app-header *ngIf="authService.isLoggedIn()"></app-header>
  <router-outlet></router-outlet>
</div>
<app-loading></app-loading>

